import React from "react";
import { BdWallet2 } from "solar-icon-react/bd";
import { cn, formatNumber } from "@/lib";
import { IDefaultPackage, IPackages } from "@/interfaces";
import styles from "@/components/Payment/paymentCheckout.module.css";

interface IUserPackage {
  id: string;
  campaign_name: string;
  remaining_days: string;
  remaining_inqueries: number;
  used_inqueries: number;
}

interface IRadioProps {
  walletBalance: number;
  packages: IUserPackage[];
  selectedPackage: IDefaultPackage | IPackages | IUserPackage | null;
  setSelectedPackage: (pkg: IDefaultPackage | IUserPackage) => void;
}

const UserPackageRadioGroup: React.FC<IRadioProps> = ({
  packages,
  selectedPackage,
  setSelectedPackage,
  walletBalance,
}) => {
  const walletPackage: IDefaultPackage = {
    id: "p0",
    name: "استعلام با اعتبار کیف پول",
    price: "0",
  };

  return (
    <form onSubmit={(event) => event.preventDefault()} className="w-full">
      <div role="radiogroup" aria-label="انتخاب اعتبار استعلام">
        <div className={styles.sectionTop}>
          <div>
            <h3>انتخاب روش استعلام</h3>
            <p className={styles.sectionHint}>
              بسته فعال یا کیف پول خود را انتخاب کنید
            </p>
          </div>
          <span className={styles.miniTag}>بسته فعال</span>
        </div>
        <div className={styles.packageGrid}>
          {packages.map((pkg, index) => {
            const selected = selectedPackage?.id === pkg.id;
            const themes = ["#4ccf8a", "#54b8f1", "#faa763", "#ff859c"];
            const backgrounds = ["#f3fff7", "#f2faff", "#fff9f1", "#fff5f7"];
            const packageStyle: React.CSSProperties &
              Record<"--plan" | "--plan-bg", string> = {
              "--plan": themes[index % themes.length],
              "--plan-bg": backgrounds[index % backgrounds.length],
            };
            return (
              <label
                key={pkg.id}
                className="block cursor-pointer"
                htmlFor={`user-package-${pkg.id}`}
              >
                <input
                  id={`user-package-${pkg.id}`}
                  className="sr-only"
                  type="radio"
                  name="package-selection"
                  checked={selected}
                  onChange={() => setSelectedPackage(pkg)}
                />
                <span
                  className={cn(
                    styles.package,
                    selected && styles.packageSelected,
                  )}
                  style={packageStyle}
                >
                  <span className={styles.packageTop}>
                    <span className={styles.packageTitle}>
                      <strong>{pkg.campaign_name}</strong>
                      <small>{pkg.remaining_days} روز اعتبار باقی‌مانده</small>
                    </span>
                    <span className={styles.discount}>فعال</span>
                  </span>
                  <span className={styles.packageBottom}>
                    <span className={styles.packageUnit}>
                      {pkg.remaining_inqueries} استعلام باقی‌مانده
                    </span>
                    <span className={styles.packageUnit}>
                      {pkg.used_inqueries} استعلام مصرف‌شده
                    </span>
                  </span>
                </span>
              </label>
            );
          })}
        </div>
        <label className="mt-4 block cursor-pointer" htmlFor="wallet-option">
          <input
            id="wallet-option"
            className="sr-only"
            type="radio"
            name="package-selection"
            checked={selectedPackage?.id === "p0"}
            onChange={() => setSelectedPackage(walletPackage)}
          />
          <span
            className={cn(
              styles.singleOption,
              selectedPackage?.id === "p0" && styles.selected,
            )}
          >
            <span className={styles.selector} />
            <span className={styles.singleIcon}>
              <BdWallet2 size={24} />
            </span>
            <span className={styles.optionMain}>
              <strong>استفاده از اعتبار کیف پول</strong>
              <span>موجودی قابل استفاده برای استعلام</span>
            </span>
            <span className={styles.optionPrice}>
              {formatNumber(walletBalance)}
              <small className={styles.currency}>تومان</small>
            </span>
          </span>
        </label>
      </div>
    </form>
  );
};

export default UserPackageRadioGroup;
